var render = function render(_c, _vm) {
  return _c("a-sub-menu", {
    key: _vm.props.currentRoute.path
  }, [_c("template", {
    slot: "title"
  }, [_vm.props.currentRoute.meta.icon ? _c("svg-icon", {
    attrs: {
      icon: _vm.props.currentRoute.meta.icon
    }
  }) : _vm._e(), _c("span", {
    staticClass: "menu-title",
    staticStyle: {
      "margin-left": "16px"
    }
  }, [_vm._v(_vm._s(_vm.props.currentRoute.meta.title))])], 1), _vm._l(_vm.props.currentRoute.children, function (item) {
    return [(!item.children || item.hiddenChildren) && !item.hidden ? _c("menu-item", {
      key: item.path,
      attrs: {
        currentRoute: item
      }
    }) : !item.hidden ? _c("sub-menu", {
      key: item.path,
      attrs: {
        currentRoute: item
      }
    }) : _vm._e()];
  })], 2);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };